module.exports = __webpack_public_path__ + "img/clearpay.7ce3483.svg";